import { createFeatureScope } from 'bundles/product-features';

export const { useProductFeatures } = createFeatureScope({
  globalCourseFeatures: {
    enableCustomLabels: false,
  },
});
